(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-width-divider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var s = document.currentScript && document.currentScript.previousElementSibling;
    // Find the section root near the script
    var root = s && s.previousElementSibling && s.previousElementSibling.matches('.wyg-full-divider')
      ? s.previousElementSibling : document.querySelector('.wyg-full-divider:last-of-type');
    if (!root) return;
    var line = root.querySelector('.wyg-full-divider__line');
    if (!line) return;

    // Pull settings from the rendered schema (Shopify injects them as data attributes is not reliable),
    // so we compute from CSS variables instead—set them via inline style below.
  })();

  } catch(e) { console.error(e); }
})();
})();
